import { useEffect, useState } from 'react';
import { X } from '@phosphor-icons/react';
import { Input } from './ui/input';
import { Label } from './ui/label';

// Chips + search to add / remove players on an already booked lesson.
export const LessonClientsEditor = ({ clients, onChange, L, API, deskPaid = 0 }) => {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => {
    if (q.length < 2) { setResults([]); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await API.get(`/users/search?q=${encodeURIComponent(q)}&limit=20`);
        setResults(data || []);
      } catch { setResults([]); }
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const add = (u) => { onChange([...clients, { id: u.id, name: u.name }]); setQ(''); setResults([]); };
  const remove = (id) => onChange(clients.filter(c => c.id !== id));
  const options = results.filter(u => !clients.some(c => c.id === u.id));

  return (
    <div className="space-y-2" data-testid="edit-lesson-clients">
      <Label className="label-text">{L('Players', 'Spieler')} <span className="text-emerald-600 font-normal">({clients.length})</span></Label>
      <div className="flex flex-wrap gap-2">
        {clients.map(c => (
          <span key={c.id} className="inline-flex items-center gap-1 pl-2 pr-1 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-semibold">
            {c.name}
            {clients.length > 1 && (
              <button type="button" onClick={() => remove(c.id)} className="rounded-full hover:bg-emerald-200 p-0.5" data-testid={`edit-remove-client-${c.id}`}>
                <X size={12} />
              </button>
            )}
          </span>
        ))}
      </div>
      {deskPaid > 0 && (
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded-md px-2 py-1" data-testid="edit-lesson-desk-paid-note">
          {L(`${deskPaid} player(s) already paid at the Kasse — check who paid before removing someone.`,
             `${deskPaid} Spieler hat/haben bereits an der Kasse bezahlt — vor dem Entfernen prüfen, wer bezahlt hat.`)}
        </p>
      )}
      <div className="relative">
        <Input value={q} onChange={(e) => setQ(e.target.value)} className="bg-slate-50 border-slate-200"
          placeholder={L('Add player: name, email or phone…', 'Spieler hinzufügen: Name, E-Mail oder Telefon…')}
          data-testid="edit-lesson-client-search" />
        {options.length > 0 && (
          <div className="absolute z-50 w-full mt-1 bg-white border border-slate-200 rounded-xl shadow-lg max-h-48 overflow-y-auto">
            {options.map(u => (
              <button key={u.id} type="button" onClick={() => add(u)}
                className="w-full text-left px-3 py-2 hover:bg-emerald-50 text-sm border-b border-slate-50 last:border-0"
                data-testid={`edit-client-option-${u.id}`}>
                <span className="font-medium text-slate-800">{u.name}</span>
                <span className="text-slate-400 ml-2 text-xs">{u.email}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
